import { useRef } from "react";
import LayoutAction from "../actions/LayoutAction";
import { useDispatch } from "react-redux";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export const CopyContentField = ({ copyingContent }) => {
  const dispatch = useDispatch();
  const ref = useRef<any>(null);

  const copyToClipBoard = async () => {
    try {
      if (ref.current) {
        ref.current.select();
        document.execCommand("copy");
        dispatch(
          LayoutAction.setNotification({
            title: "API Key",
            type: "success",
            message: "Copied!",
          })
        );
      }
    } catch {
      dispatch(
        LayoutAction.setNotification({
          title: "API Key",
          type: "error",
          message: "No API Key",
        })
      );
    }
  };

  return (
    <div className={"space-y-4 items-center"}>
      <textarea
        cols={1}
        disabled
        readOnly
        value={copyingContent}
        ref={ref}
        className={"flex w-full bg-gray-200 items-center rounded-sm p-4"}
      ></textarea>
      <ClipboardDocumentIcon
        className={"w-6 text-blue-400 hover:text-blue-600 cursor-pointer"}
        onClick={() => copyToClipBoard()}
      />
    </div>
  );
};

const ZapierSetting = ({ appInfo }) => {
  const { t } = useTranslation();
  const { accessToken = {}, connected } = appInfo;
  if (connected) {
    return (
      <div className={"space-y-2"}>
        <div className={"font-bold"}>{t("Setup steps")}</div>
        <div className={"space-y-2 align-middle"}>
          <div className={"font-medium leading-6 text-gray-900"}>{t("Step 1: Copy API key")}</div>
          <CopyContentField copyingContent={accessToken.apiKey} />
        </div>
        <div className={"space-y-2 align-middle"}>
          <div className={"font-medium leading-6 text-gray-900"}>
            {t("Step 2: Setup API key for Zapier")}
          </div>
          <a
            className={
              "inline-flex items-center gap-x-1.5 rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            }
            target={"_top"}
            href={"https://zapier.com/engine/auth/start/App210259CLIAPI@1.0.0/"}
          >
            {t("Connect Zapier")}
          </a>
        </div>
        <div className={"space-y-2 align-middle"}>
          <div className={"font-medium leading-6 text-gray-900"}>{t("Step 3: Yay!!! - Done")}</div>
          <a
            className={
              "inline-flex items-center gap-x-1.5 rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            }
            href={"https://zapier.com/apps/pipelinedeals/integrations"}
          >
            {t("Zapier Templates")}
          </a>
        </div>
      </div>
    );
  }
  return <div>{t("Zapier app is disabled.")}</div>;
};

export default ZapierSetting;
